<template>
  <a :href="googleTranslateLink" target="_blank" title="Translate">
    Translate with Google Translate
  </a>
</template>

<script>
export default {
  props: ["text"],
  computed: {
    googleTranslateLink() {
      return this.toGoogleTranslateLink(this.text);
    }
  },
  methods: {
    toGoogleTranslateLink(text) {
      const encodedText = encodeURIComponent(text);
      return `https://translate.google.com/#view=home&op=translate&sl=auto&tl=en&text=${encodedText}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
